<script setup>
import { ref } from 'vue';
import {
  EMAIL_PROVIDERS,
  providerNeedsDomain,
  resolveProvider,
} from '../helpers/emailProviders';

const emit = defineEmits(['apply']);

// Configuracao rapida de provedor de email. Ao escolher um preset, emite os
// hosts/portas/SSL pro componente pai. Os presets moram em helpers/emailProviders
// porque a criacao da caixa usa a mesma lista.

const selectedKey = ref('');
const domain = ref('');
const note = ref('');

const onApply = () => {
  const resolvido = resolveProvider(selectedKey.value, domain.value);
  if (!resolvido) return;

  note.value = resolvido.note;
  emit('apply', {
    imap: resolvido.imap,
    smtp: resolvido.smtp,
    providerKey: selectedKey.value,
  });
};

const needsDomain = () => providerNeedsDomain(selectedKey.value);

const ui = {
  title: 'Configuração rápida',
  help: 'Escolha seu provedor pra pré-preencher servidor, porta e criptografia.',
  provider: 'Provedor',
  select: '— selecione —',
  yourDomain: 'Seu domínio',
  domainPh: 'ex: empresa.com.br',
  apply: 'Aplicar',
};
</script>

<template>
  <div class="mb-4 p-3 border border-n-weak rounded-lg bg-n-stone-25">
    <div class="flex items-center gap-2 mb-2">
      <span class="i-lucide-zap size-4 text-n-amber-11" />
      <h4 class="text-sm font-semibold text-n-slate-12">{{ ui.title }}</h4>
    </div>
    <p class="text-xs text-n-slate-10 mb-3">
      {{ ui.help }}
    </p>

    <div class="flex items-end gap-2 flex-wrap">
      <label class="text-xs text-n-slate-11 flex-1 min-w-[180px]">
        {{ ui.provider }}
        <select
          v-model="selectedKey"
          class="reset-base w-full mt-1 text-sm border border-n-weak rounded-lg px-3 py-2 bg-n-background text-n-slate-12"
        >
          <option value="">{{ ui.select }}</option>
          <option v-for="p in EMAIL_PROVIDERS" :key="p.key" :value="p.key">
            {{ p.label }}
          </option>
        </select>
      </label>

      <label
        v-if="selectedKey && needsDomain()"
        class="text-xs text-n-slate-11 flex-1 min-w-[180px]"
      >
        {{ ui.yourDomain }}
        <input
          v-model="domain"
          type="text"
          :placeholder="ui.domainPh"
          class="reset-base w-full mt-1 text-sm border border-n-weak rounded-lg px-3 py-2 bg-n-background text-n-slate-12"
        />
      </label>

      <button
        type="button"
        class="px-3 py-2 text-xs font-medium text-white bg-woot-500 rounded-lg hover:bg-woot-600 disabled:opacity-50"
        :disabled="!selectedKey || (needsDomain() && !domain)"
        @click="onApply"
      >
        {{ ui.apply }}
      </button>
    </div>

    <p
      v-if="note"
      class="mt-2 text-[11px] text-n-amber-12 bg-n-amber-2 border border-n-amber-6 rounded px-2 py-1.5"
    >
      {{ note }}
    </p>
  </div>
</template>
